module.exports = __webpack_public_path__ + "img/activity_1.f8e82223.png";